import { QueryClientProvider, QueryClient } from 'react-query';
import { ThemeProvider } from '@mui/material/styles';
import customTheme from 'styles/theme';
import 'styles/globalStyles.scss';

const queryClient = new QueryClient();

const SystemProvider = ({ children }) => (
  <ThemeProvider theme={customTheme}>
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  </ThemeProvider>
);

export default SystemProvider;
